import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";

var Token =
/*#__PURE__*/
function () {
  function Token() {
    _classCallCheck(this, Token);
  }

  _createClass(Token, [{
    key: "setExpiration",

    /* Store the session keys */
    value: function setExpiration(sessionData) {
      localStorage.setItem('expiration', JSON.stringify(sessionData));
      return this.getExpiration();
    }
  }, {
    key: "setCreated",
    value: function setCreated(sessionData) {
      localStorage.setItem('created', JSON.stringify(sessionData));
      return this.getCreated();
    }
  }, {
    key: "setRefresh",
    value: function setRefresh(sessionData) {
      localStorage.setItem('refresh', JSON.stringify(sessionData));
      return this.getRefresh();
    }
  }, {
    key: "setProfile",
    value: function setProfile(sessionData) {
      localStorage.setItem('profile', JSON.stringify(sessionData));
      return this.getProfile();
    }
  }, {
    key: "setPermissions",
    value: function setPermissions(sessionData) {
      localStorage.setItem('permissions', JSON.stringify(sessionData));
      return this.getPermissions();
    }
  }, {
    key: "setPagePermissions",
    value: function setPagePermissions(sessionData) {
      localStorage.setItem('pagePermissions', JSON.stringify(sessionData));
      return this.getPagePermissions();
    }
  }, {
    key: "setMfaSession",
    value: function setMfaSession(sessionData) {
      localStorage.setItem('mfaSession', JSON.stringify(sessionData));
      return this.getMfaSession();
    }
    /* Retrieve session data via key */

  }, {
    key: "getExpiration",
    value: function getExpiration() {
      if (localStorage.getItem('expiration') !== null) {
        return JSON.parse(localStorage.getItem('expiration'));
      } else {
        return null;
      }
    }
  }, {
    key: "getCreated",
    value: function getCreated() {
      if (localStorage.getItem('created') !== null && localStorage.getItem('created') !== undefined) {
        return JSON.parse(localStorage.getItem('created'));
      } else {
        return null;
      }
    }
  }, {
    key: "getRefresh",
    value: function getRefresh() {
      if (localStorage.getItem('refresh') !== null && localStorage.getItem('refresh') !== undefined) {
        return JSON.parse(localStorage.getItem('refresh'));
      } else {
        return null;
      }
    }
  }, {
    key: "getProfile",
    value: function getProfile() {
      if (localStorage.getItem('profile') !== null) {
        return JSON.parse(localStorage.getItem('profile'));
      } else {
        return null;
      }
    }
  }, {
    key: "getPermissions",
    value: function getPermissions() {
      if (localStorage.getItem('permissions') !== null) {
        return JSON.parse(localStorage.getItem('permissions'));
      } else {
        return null;
      }
    }
  }, {
    key: "getPagePermissions",
    value: function getPagePermissions() {
      if (localStorage.getItem('pagePermissions') !== null) {
        return JSON.parse(localStorage.getItem('pagePermissions'));
      } else {
        return null;
      }
    }
  }, {
    key: "getMfaSession",
    value: function getMfaSession() {
      if (localStorage.getItem('mfaSession') !== null) {
        return JSON.parse(localStorage.getItem('mfaSession'));
      } else {
        return null;
      }
    }
    /* Delete session data */

  }, {
    key: "deleteSession",
    value: function deleteSession() {
      localStorage.removeItem('expiration');
      localStorage.removeItem('created');
      localStorage.removeItem('refresh');
      localStorage.removeItem('profile');
      localStorage.removeItem('permissions');
      localStorage.removeItem('pagePermissions');
      localStorage.removeItem('logo');
    }
  }, {
    key: "deleteMfaSession",
    value: function deleteMfaSession() {
      localStorage.removeItem('mfaSession');
    }
  }]);

  return Token;
}();

export { Token as default };